import React, { Suspense, useState, useEffect } from "react";
import "../My_Profile/myProfile.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "reactstrap";
import Loading from "../../components/Loading";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { loadUser } from "../../actions/authActions";

const MyProfile = (props) => {

  const { frontLabelsName } = props.label;
  const userName = props.auth.user;

  useEffect(() => {
    props.loadUser();
  }, []);

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container  mb-5 pt-5">
        <div className="row">
          <div className="col-md-12">
            <div className="my-profile-main">
              <div className="my-profile-box">
                <div className="row mt-4">
                  <div className="col-lg-3">
                    <div className="profile-img-box text-center">
                      <img src={userName?.profile_pic} alt="user-profile" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="profile-details pt-4">
                      <h2 className="mb-5">{userName?.full_name}</h2>
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_email"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_email"
                                      )[0]["value"] || "lbl_email"
                                    : "lbl_email"
                                  : "lbl_email"}
                                :
                              </strong>
                            </p>{" "}
                            <div className="dss-dd-con mb-3">
                              <p>{userName?.email}</p>
                            </div>{" "}
                          </div>

                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_social_security_no"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_social_security_no"
                                      )[0]["value"] || "lbl_social_security_no"
                                    : "lbl_social_security_no"
                                  : "lbl_social_security_no"}
                                :
                              </strong>
                            </p>{" "}
                            <div className="dss-dd-con mb-3">
                              <p>{userName?.ss_number}</p>
                            </div>{" "}
                          </div>

                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_zip_code"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_zip_code"
                                      )[0]["value"] || "lbl_zip_code"
                                    : "lbl_zip_code"
                                  : "lbl_zip_code"}
                                :
                              </strong>
                            </p>{" "}
                            <div className="dss-dd-con mb-3">
                              <p>{userName?.zcode}</p>
                            </div>{" "}
                          </div>

                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_state"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_state"
                                      )[0]["value"] || "lbl_state"
                                    : "lbl_state"
                                  : "lbl_state"}
                                :
                              </strong>
                            </p>{" "}
                            <div className="mb-3 ps-3">
                              <p>{userName?.state}</p>
                            </div>{" "}
                          </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_contact_no"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_contact_no"
                                      )[0]["value"] || "lbl_contact_no"
                                    : "lbl_contact_no"
                                  : "lbl_contact_no"}
                                :
                              </strong>
                            </p>{" "}
                            <div className="dss-dd-con mb-3">
                              <p>{userName?.mobile_number}</p>
                            </div>{" "}
                          </div>

                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_company1"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_company1"
                                      )[0]["value"] || "lbl_company1"
                                    : "lbl_company1"
                                  : "lbl_company1"}
                                :
                              </strong>
                            </p>{" "}
                            <div className="dss-dd-con mb-3 ">
                              <p>{userName?.companyName}</p>
                            </div>{" "}
                          </div>

                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_city"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_city"
                                      )[0]["value"] || "lbl_city"
                                    : "lbl_city"
                                  : "lbl_city"}
                                :
                              </strong>
                            </p>{" "}
                            <div className="dss-dd-con mb-3">
                              <p>{userName?.city}</p>
                            </div>{" "}
                          </div>

                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_location"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_location"
                                      )[0]["value"] || "lbl_location"
                                    : "lbl_location"
                                  : "lbl_location"}
                                :
                              </strong>
                            </p>{" "}
                            <div className="mb-3 ps-3">
                              <p>{userName?.location}</p>
                            </div>{" "}
                          </div>
                        </div>

                        <div className="col-12 col-md-6 d-flex justify-content-between">
                          <p>
                            <strong>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_address"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_address"
                                    )[0]["value"] || "lbl_address"
                                  : "lbl_address"
                                : "lbl_address"}
                              :
                            </strong>
                          </p>
                          <div className="mb-3 ps-3">
                            <p>{userName?.address}</p>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="button-set-edit text-center justify-content-center">
                      <Link to="/edit-profile">
                        <Button>
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_edit")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_edit"
                                )[0]["value"] || "lbl_edit"
                              : "lbl_edit"
                            : "lbl_edit"}
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, { loadUser })(MyProfile);
